/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} QuantityInputs */

const en_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quantity`)
};

const es_quantity = /** @type {(inputs: QuantityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cantidad`)
};

/**
* | output |
* | --- |
* | "Quantity" |
*
* @param {QuantityInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const quantity = /** @type {((inputs?: QuantityInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<QuantityInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quantity(inputs)
	return es_quantity(inputs)
});